export const environment = {
  production: false,
  apiUrl: 'https://quasar.des.arbor.quasar.tec.br/arbor/',

  auth: {
    username: '33.870.041/0001-98',
    password: 'HgtUop@8',
  },

  security: {
    checkToken: '/service/autenticacao/checkToken',
    login: 'service/autenticacao/login',
    refreshToken: '/service/autenticacao/refreshToken',
  },

  contributors: {
    list: '/service/contribuintes/listar',
  },

  stages: {
    update: (idEtapa: number) => `/service/etapa/${idEtapa}/alterar`,
  },

  properties: {
    list: '/service/imoveis/listar',
  },

  processes: {
    update: (idProcesso: number) => `service/processo/${idProcesso}/alterar`,
    delete: (idProcesso: number) => `service/processo/${idProcesso}/remover`,
    create: 'service/processo/criar',
    list: (idTipoProcesso: number) => `service/processo/${idTipoProcesso}/listar`,
  },

  processTypes: {
    modalities: '/service/processo/modalidades',
    types: '/service/processo/tipos',
    openingTypes: '/service/processo/tipos/abertura',
    openingModalities: '/service/processo/modalidades/abertura',
  },

  units: {
    findById: (id: number) => `/service/unidades/${id}`,
    list: '/service/unidades/listar',
  },

  users: {
    findById: (id: number) => `/service/usuarios/${id}`,
    list: '/service/usuarios/listar',
  },
};